export default {
    LABEL: 'Form 表单',
    DESC: '由输入框、选择器、单选框、多选框等控件组成，用以收集、校验、提交数据.',
    COMPONENTS: {
        Base: {
            LABEL: '基础用法',
            DESC: '',
        },
        Round: {
            LABEL: '圆角',
            DESC: '',
        },
        Disabled: {
            LABEL: '禁用状态',
            DESC: '',
        },
        Size: {
            LABEL: '大小',
            DESC: '提供了 mini、small、normal、big 四种尺寸.',
        },
        Circle: {
            LABEL: '圆形矩形',
            DESC: '提供弧度感觉的圆角矩形',
        },
        Icon: {
            LABEL: '图标',
            DESC: '提供带有图标的弧度感觉的圆角矩形',
        },
        CircleIcon: {
            LABEL: '圆形图标',
            DESC: '提供圆形图标按钮',
        },
    },
};
